import gql from 'graphql-tag'

const listProductLabelGroups = gql`
query listProductLabelGroups {
	cashAssist {
		listProductLabelGroups {
			id
			mod_ver
			name
		}
	}
}
`

export default listProductLabelGroups
